<div class="container">
  <h1>Enquiry Sent!</h1>
  <br />

  <p>
    Your enquiry has been sent and you will be contacted shortly.
    A copy of your enquiry has also been sent to the email address you provided.
  </p>

  <button class="okBtn" mat-button mat-raised-button type="button" (click)="back()" color="primary">
    Ok
  </button>
</div>